import { BoxProps } from '@reckon-web/box';
import { Flex } from '@reckon-web/flex';
import { LoadingDots } from '@reckon-web/loading';

type Sizes = 'small' | 'medium' | 'large';

type Props = BoxProps & {
  inline?: boolean;
  background?: 'muted' | 'base' | undefined;
  size?: Sizes;
  label: string;
};

export const Loader = ({
  inline,
  label,
  size = 'medium',
  background = 'muted',
  paddingBottom = 'xxlarge',
  borderRadius = 'medium',
  ...rest
}: Props) => {
  return inline ? (
    <LoadingDots label={label} size={size} />
  ) : (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      flexGrow={1}
      background={background}
      {...rest}
    >
      <LoadingDots label={label} size={size} />
    </Flex>
  );
};
